var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative",on:{"click":_vm.toggle}},[_c('button',{class:_vm.active ? 'btn-active-filter' : null,attrs:{"type":"button"}},[_vm._t("toggle")],2),_vm._v(" "),_c('div',{directives:[{name:"on-dismiss",rawName:"v-on-dismiss",value:({
      watch: _vm.active,
      callback: _vm.dismiss,
    }),expression:"{\n      watch: active,\n      callback: dismiss,\n    }"}],staticClass:"absolute right-0 flex flex-col z-50 rounded bg-white shadow-md transform transition-all duration-300 ease-in-out font-medium text-lg",class:_vm.classes},[_vm._t("items")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }